var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RenderBlock } from '../../render-layout.models';
/**
 * Lobby lotteries grid - template-9 variant: a card per lottery showing logo/details/jackpot and,
 * on hover, the last draw's winning numbers with a play action. No quick-play / show-more (those
 * are template-7's grid). Lottery data lives on the shell (host).
 */
var LotteriesGridT9 = /** @class */ (function (_super) {
    __extends(LotteriesGridT9, _super);
    function LotteriesGridT9() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LotteriesGridT9;
}(RenderBlock));
export { LotteriesGridT9 };
